import React from 'react'
import { connect } from 'react-redux'
import CartIcon from '@tecuity/sos-icons/react/cart'
import SlidingPanel from 'components/SlidingPanel/SlidingPanel'
import Portal from 'components/Portal/Portal'
import ConnectedCheckout from 'components/Checkout/Checkout'
import { GET_WEB_USER_ACTIVE_CART } from 'requests'
import { setCartQuantity } from '../../actions'
import { history } from '../../store'
import './Cart.scss'

let CartButton = ({ loggedIn, cartQuantity, setCartQuantity }) => {
  const [checkoutOpen, setCheckoutOpen] = React.useState(false)
  const [currentCart, setCurrentCart] = React.useState({})
  const slidingPanelRef = React.useRef()

  const closeCheckout = () => {
    slidingPanelRef.current.closeSlider(() => {
      setCheckoutOpen(false)
    })
  }

  const startCheckout = () => {
    GET_WEB_USER_ACTIVE_CART( cart => {
      setCurrentCart(cart)
      setCartQuantity(cart.RECEIPT_ITEM_CONTAINER_WEB_LIST.filter(x => !x.IS_FREE).length)
      setCheckoutOpen(true)
    })
  }

  const refreshCart = () => {
    GET_WEB_USER_ACTIVE_CART( cart => {
      setCurrentCart(cart)
      setCartQuantity(cart.RECEIPT_ITEM_CONTAINER_WEB_LIST.filter(x => !x.IS_FREE).length)
    })
  }

  const redirectToReceipt = (refNum) => {
    history.push(`/receipt?ref=${refNum || currentCart.REF_NUM}`)
  }

  return (
    loggedIn && (
      <div className="cart-button-wrapper" >
        <button className="cart-button" onClick={startCheckout} aria-label="Open Shopping Cart">
          {!!cartQuantity && (
            <div className="cart-amount">
              <span>{cartQuantity}</span>
            </div>
          )}
          <div className="flex-center">
            <CartIcon />
          </div>
        </button>
        <Portal isOpened={checkoutOpen}>
          <SlidingPanel closeOnShadeClick={false} closeSlider={closeCheckout} ref={slidingPanelRef} ariaLabel="Checkout">
            <ConnectedCheckout
              cancelCheckout={closeCheckout}
              closeModal={closeCheckout}
              redirectToReceipt={redirectToReceipt}
              refNum={currentCart.REF_NUM}
              // category={match.params.category}
              receiptItemContainers={currentCart.RECEIPT_ITEM_CONTAINER_WEB_LIST}
              onCartRefresh={refreshCart}
            />
          </SlidingPanel>
        </Portal>
      </div>
    )
  )
}
CartButton = connect(state => ({
  loggedIn: state.auth.loggedIn,
  cartQuantity: state.app.cartQuantity
}), {setCartQuantity})(CartButton)

export default CartButton



// WEBPACK FOOTER //
// ./src/components/Cart/Cart.js